import { IFeatureFlag } from '../interfaces/IFeatureFlag';

export const featureFlagEnabled = (featureFlags, featureName) => {
    const cruiseAwayDirectBookingFeatureFlag = featureFlags?.find(
        (flag: IFeatureFlag) => flag.feature === featureName,
    );

    return cruiseAwayDirectBookingFeatureFlag?.isEnabled;
};
